// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"style-module__subtitle___XFM7o","editIcon":"style-module__editIcon___sPrIr","editWrapper":"style-module__editWrapper___llYIT"};